import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { api, fileUrl } from "../../lib/api";
import { SectionTitle, Sparkle } from "./Decor";

export const Stars = ({ n, className = "h-4 w-4" }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${className} ${i <= n ? "fill-[#D4A537] text-[#D4A537]" : "text-[#D4A537]/30"}`} />)}
  </div>
);

const ReviewCard = ({ r }) => (
  <figure className="flex h-full break-inside-avoid flex-col overflow-hidden rounded-3xl bg-white ring-1 ring-[#EBD08A] transition-transform duration-300 hover:-translate-y-1" data-testid={`review-card-${r.id}`}>
    {r.storage_path && <img src={fileUrl(r.storage_path)} alt={r.product || `${r.name}'s order`} loading="lazy" className="aspect-[4/3] w-full object-cover" />}
    <div className="flex flex-1 flex-col p-6">
      <Quote className="h-7 w-7 fill-[#FF1F8E]/15 text-[#FF1F8E]" />
      <blockquote className="mt-3 flex-1 text-base leading-relaxed text-[#0E0B0D]/80">"{r.quote}"</blockquote>
      <div className="stitch-line my-5 w-16" />
      <figcaption className="flex items-end justify-between gap-3">
        <div>
          <p className="font-display text-lg font-bold">{r.name}</p>
          {r.product && <p className="text-xs uppercase tracking-[0.18em] text-[#D4A537]">{r.product}</p>}
        </div>
        <Stars n={r.rating} />
      </figcaption>
    </div>
  </figure>
);

export const Reviews = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="relative overflow-hidden bg-[#FFF4F8]" data-testid="home-reviews">
      <Sparkle className="absolute right-[10%] top-14" size={20} />
      <div className="mx-auto max-w-7xl px-6 py-20">
        <SectionTitle eyebrow="Happy customers" title="Stitched with love," script="loved by you" />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
          {items.slice(0, 6).map((r) => <ReviewCard key={r.id} r={r} />)}
        </div>
      </div>
      <div className="stitch-line" />
    </section>
  );
};
